import { DEFAULT_PURCHASES_COMPLETE_FILTERS_STATE } from 'Stores/AccountFiltersStore/AccountFiltersStore.consts';

export const DEFAULT_FILTER_PAIRS = { ...DEFAULT_PURCHASES_COMPLETE_FILTERS_STATE, page: 1 };
export const EXCLUDED_FILTERS = ['sortBy', 'order']; // These are not filters, but query params and can affect message displayed
